import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import "./AdminPage.css";
import PieChartComponent from "../../components/piechart/PieChartComponent";
import TotalGuestCount from "../../components/totalGuestCount/TotalGuestCount";
import SaleCount from "../../components/SaleCount/SaleCount";
import MostBookedTours from "../../components/mostbookedTours/MostBookedTours";

const AdminPage = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current URL path
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const inactivityTimer = useRef(null);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    alert("Session expired due to inactivity. Logging out.");
    navigate("/ttc/login");
    window.scrollTo(0, 0);
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }
    inactivityTimer.current = setTimeout(handleLogout, 300000);
  }, [handleLogout]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/ttc/login");
    } else {
      resetTimer();
      window.addEventListener("mousemove", resetTimer);
      window.addEventListener("keydown", resetTimer);
    }

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }
    };
  }, [navigate, resetTimer]);

  return (
    <div className="admin-container">
      <div className="admin-box">
        <h1 className="admin-title">Welcome, Admin!</h1>
        <p className="admin-text">Manage all bookings below.</p>
        <button
          className="admin-button homeAdminBtn"
          onClick={() => {
            navigate("/ttc/admin");
            window.scrollTo(0, 0);
          }}
        >
          Home
        </button>
        <button
          className="admin-button submittedFormBtn"
          onClick={() => {
            navigate("/ttc/admin/submitted");
            window.scrollTo(0, 0);
          }}
        >
          All Bookings
        </button>
        <button
          className="admin-button doneBkngsAdminBtn"
          onClick={() => {
            navigate("/ttc/admin/done");
            window.scrollTo(0, 0);
          }}
        >
          Done Bookings
        </button>
        <button
          className="admin-button dltdBkngsAdminBtn"
          onClick={() => {
            navigate("/ttc/admin/deleted");
            window.scrollTo(0, 0);
          }}
        >
          Deleted Bookings
        </button>
        <button className="admin-button logoutBtn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      {/* ✅ Show only on `/ttc/admin` (not on sub-routes) */}
      {location.pathname === "/ttc/admin" && (
        <>
          <div className="adminTotalContainer">
            <TotalGuestCount className="items" />
            <SaleCount className="items" />
          </div>
          <PieChartComponent />
          <MostBookedTours />
        </>
      )}

      {/* 👇 This Outlet will display the sub-routes inside AdminPage */}
      <Outlet />
    </div>
  );
};

export default AdminPage;
